<template>
    <div class="flex flex-col mx-auto max-w-3xl w-full text-center">
        <div class="bg-gradient-to-r flex flex-col md:flex-row from-xiaomi via-red-500 to-pink-500 text-white px-8 py-6 mb-5 rounded-lg">
            <div class="flex items-center">
                <span class="text-xl">{{ type | verbose_insurance }}</span>
                <span class="flex text-orange-300 leading-none hidden">
                    <span class="text-4xl text-white">10</span>
                    <span>€</span>
                    <span class="mt-auto text-orange-200 ml-2 mb-1">/ mois</span>
                </span>
                <span class="text-orange-300 hidden">1 an d'assurance</span>
            </div>

            <button @click="goBack" class="ml-auto mt-3 md:mt-0 my-auto border-2 font-semibold text-sm border-white p-2 rounded hover:bg-white hover:bg-opacity-25">Modifier l'assurance</button>
        </div>

        <div class="flex flex-col">
            <form v-on:submit.prevent="estimate" v-if="!estimated" class="flex flex-col items-center leading-none mx-auto py-4 space-y-5 w-full">
                <div class="flex flex-col md:flex-row w-auto items-start justify-between md:space-x-10 space-y-5 md:space-y-0 w-full">
                    <aff-input label="Téléphone" type="select" :options="options" v-model="product.model"/>
                    <aff-input label="Prix d'achat" v-model="product.price" type="number" hint="Prix TTC hors accessoires" />
                </div>

                <input type="submit" v-if="!isLoading" :disabled="!isValid" value="Obtenir une estimation" class="p-4 px-8 cursor-pointer bg-green-500 hover:bg-green-600 text-white rounded ml-auto disabled:opacity-75 disabled:cursor-not-allowed"/>
                <span class="ml-auto p-4 px-8" v-else>Chargement du tarif...</span>
            </form>

            <div class="flex flex-col md:flex-row md:space-x-5 space-y-3 md:space-y-0" v-if="estimated">
                <button @click.prevent="confirmType(estimated.main_type, estimated.main_monthly_price)" class="border-2 bg-gray-100 flex flex-col text-center items-center text-gray-700 p-8 md:w-64 rounded">
                    <span>{{ estimated.main_type | verbose_insurance }}</span>
                    <span class="my-3 flex flex-col items-center text-black">
                        <span class="flex -mr-1">
                            <span class="text-3xl">{{ estimated.main_monthly_price / 100 }}</span>
                            <span>€</span>
                        </span>
                        <span class="-ml-1 mt-auto text-sm">par mois</span>
                    </span>
                    <span class="text-sm text-gray-500">Selectionner</span>
                </button>

                <button @click.prevent="confirmType(upsell.type, upsell.monthly_price)" v-for="upsell in estimated.upsells" :key="upsell.type" class="border-2 bg-gray-100 flex flex-col text-center items-center text-gray-700 p-8 md:w-64 rounded">
                    <span>{{ upsell.type | verbose_insurance }}</span>
                    <span class="my-3 flex flex-col items-center text-black">
                        <span class="flex -mr-1">
                            <span class="text-3xl">{{ upsell.monthly_price / 100 }}</span>
                            <span>€</span>
                        </span>
                        <span class="-ml-1 mt-auto text-sm">par mois</span>
                    </span>
                    <span class="text-sm text-gray-500">Selectionner</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
const axios = require('axios');
import AffInput from '@/components/inputs/AffInput'

export default {
    components: { AffInput },
    props: ['type', 'value'],
    data: function () {
        return {
            estimated: null,
            isLoading: false,
            product: {
                price: null,
                model: null
            },
            options: [{label: 'Mi Note 10'}]
        };
    },
    mounted: function () {
        if(this.value != null) {
            this.product = Object.assign({}, this.value);
        }
    },
    computed: {
        isValid: function () {
            const productPriceFloat = parseFloat(this.product.price);
            return (this.product.price && this.product.price && productPriceFloat > 0) == true;
        }
    },
    methods: {
        goBack: function () {
            this.$emit('go-back');
        },
        estimate: function () {
            const payload = {
                type: this.type,
                product_price: parseFloat(this.product.price) * 100
            };

            const options = {
                headers: {
                    token: window.sessionStorage.getItem('shop_token'),
                    username: window.sessionStorage.getItem('shop_username')
                }
            };

            this.isLoading = true;

            axios
            .post(process.env.VUE_APP_API_BASE_URL + 'xiaomi_care/shop/enroll/estimate', payload)
            .then(({data}) => {
                this.estimated = data;
                 this.isLoading = false;
            })
        },
        confirmType: function (type) {
            this.$emit('confirm-type', {type: type, product: this.product});
        }
    }
}
</script>